import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import useLanguageFilterLogic from './hooks/useLanguageFilterLogic';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LanguageFilterAlert = () => {
  const {
    filterLanguage,
    portalLanguage,
    alertDismissed,
    dontShowAgain,
    userAttributesError,
    userAttributesLoading,
    dontShowAgainChecked,
    setDontShowAgainChecked,
    handleDismissClick
  } = useLanguageFilterLogic();
  const {
    isMobile
  } = useMediaQuery();
  const isEnglishPortal = portalLanguage === 'en';
  if (isEnglishPortal && filterLanguage === 'en' || !isEnglishPortal && filterLanguage !== portalLanguage || alertDismissed || dontShowAgain || userAttributesError || userAttributesLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "200",
    marginBlockStart: isMobile ? '300' : '200',
    titleText: isEnglishPortal ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.languageFilterAlerts.languageFilterApplied.englishPortal.alertTitle",
      options: {
        language: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `i18nAddon.languages.${filterLanguage}`
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.languageFilterAlerts.languageFilterApplied.nonEnglishPortal.alertTitle",
      options: {
        language: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `i18nAddon.languages.${filterLanguage}`
        })
      }
    }),
    type: "info",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: isMobile ? 'column' : 'row',
      gap: "400",
      inlineSize: "100%",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(View, {
        children: isEnglishPortal ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.languageFilterAlerts.languageFilterApplied.englishPortal.alertSubtitle"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.languageFilterAlerts.languageFilterApplied.nonEnglishPortal.alertSubtitle"
        })
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        gap: "400",
        children: [/*#__PURE__*/_jsx(Checkbox, {
          alignment: "center",
          checked: dontShowAgainChecked,
          onChange: ({
            target: {
              checked
            }
          }) => setDontShowAgainChecked(checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.languageFilterAlerts.dontShowAgain"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleDismissClick,
          size: "sm",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.languageFilterAlerts.gotIt"
          })
        })]
      })]
    })
  });
};
export default LanguageFilterAlert;